import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("contact@trentonfranklin.com");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success("Welcome back, Trenton.");
            nav("/dashboard");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Invalid credentials");
        } finally { setLoading(false); }
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "var(--gt-bg)" }}>
            <div className="absolute inset-0 gt-grid-bg pointer-events-none"></div>
            <div className="relative w-full max-w-md gt-card p-8" data-testid="login-card">
                <a href="/" className="flex items-center gap-3 mb-6">
                    <span className="w-9 h-9 flex items-center justify-center" style={{ background: "var(--gt-accent)" }}>
                        <i className="fa-solid fa-camera-retro" style={{ color: "#1a0f0a", fontSize: 14 }}></i>
                    </span>
                    <div className="font-display text-xl">First Landing Studio</div>
                </a>
                <h1 className="font-display text-2xl mb-2">Owner Portal</h1>
                <p className="text-sm mb-6" style={{ color: "var(--gt-text-2)" }}>Sign in to manage assignments, consents, packages, and invoices.</p>
                <form onSubmit={submit} className="space-y-4">
                    <div>
                        <label className="overline block mb-2">Email</label>
                        <input data-testid="login-email" type="email" className="gt-input" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    </div>
                    <div>
                        <label className="overline block mb-2">Password</label>
                        <input data-testid="login-password" type="password" className="gt-input" value={password} onChange={(e) => setPassword(e.target.value)} required />
                    </div>
                    <button data-testid="login-submit" disabled={loading} className="gt-btn-primary w-full py-3 text-sm">
                        {loading ? "Signing in…" : "Sign In"}
                    </button>
                </form>
                <div className="mt-6 overline" style={{ fontSize: 10, color: "var(--gt-muted)" }}>
                    Owner-only. No public photographer signups at MVP.
                </div>
            </div>
        </div>
    );
}
